import React, { useEffect } from 'react'
import classes from './Recommneted.module.css'
import { Link } from 'react-router-dom';

function NewDisney(recommendy) {
  let setRight = recommendy.recommendy.filter((item) => {
    console.log(item.type);
    return item.type === "new";
  });
  useEffect(()=>{
console.log(setRight)
  },[setRight])
    // const movies = useSelector(selectRecommend);
    // console.log(recommendy)
    // console.log(movies, ":🛢️");
  return (
    <div className={classes.container}>
New Disney +
    <div className={classes.recomends}>
    {
  setRight && setRight.map((item) => (
    <Link to={`/details/:${item.id}`}>
    <div key={item.id} className={classes.recomend}>
      <img src={item.cardImg} alt="" />
    </div>
    </Link>
  ))
}
     
    </div>
    </div>
  )
}

export default NewDisney
